module.exports = __webpack_public_path__ + "media/images/companyPage/respect-be7d197fd76c69d62cda0ba0dbb07ca3.svg";